<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Description"
                v-model="selectedLuPriority.Description"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuPriority.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveLuPriorityDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuPriority from '@classes/LuPriority'
//templateTODO: import lookup components you plan to use
export default {
  components: {},
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuPriority: new LuPriority(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luPriority', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luPriority', ['saveLuPriority']),
    async validate() {
      this.$refs.form.validate()
    },
    editLuPriority(entry) {
      this.selectedLuPriority = new LuPriority(entry)
      this.modalText = 'Edit Priority'
      this.dialog = !this.dialog
    },
    addLuPriority() {
      this.modalText = 'Insert Priority'
      this.selectedLuPriority = new LuPriority()
      this.dialog = !this.dialog
    },
    saveLuPriorityDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveLuPriority(this.selectedLuPriority.removeRelated()).then(
            (res) => {
              this.$emit('refresh')
              this.selectedLuPriority = new LuPriority()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuPriority = new LuPriority()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
